import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getPalletConfigurationList(params) {
  return request({
    url: URL.mdm.basicData.palletConfiguration,
    method: 'get',
    params
  })
}

export function savePalletConfiguration(data) {
  return request({
    url: URL.mdm.basicData.palletConfiguration,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

export function delPalletConfiguration(uuid) {
  return request({
    url: URL.mdm.basicData.palletConfiguration + '?uuid=' + encodeURIComponent(uuid),
    method: 'delete'
  })
}
